export const IkeSystem = {
	/** IKE Office related system information */
	OFFICE: 'office' as const,
	/** IKE field related systems, eg logging elastic indexes */
	FIELD: 'field' as const,
};

export type IkeSystem = typeof IkeSystem.FIELD | typeof IkeSystem.OFFICE;
